const ComponentsLookup = {
  "default-footer": "DefaultFooter4e8c0de80ae14904B4e26d7645aed1dd"
}

export default ComponentsLookup;